import { clientAuth } from './component/clientAuth/reducer/reducer';
import { bokun } from './component/bokun/redux/reducer';
import automatic_product from './component/automaticProduct/redux/reducer';
import circuit, { circuitSlice } from './component/circuit/redux/reducer';
import circuit_category from './component/circuitCategory/redux/reducer';
import connected_activities from './component/connectedActivities/redux/reducer';
import currency from './component/currency/redux/reducer';
import custom_currency from './component/customCurrency/redux/reducer';
import custom_provider from './component/customProvider/redux/reducer';
import destination from './component/destination/redux/reducer';
import destination_category from './component/destinationCategory/redux/reducer';
import destination_guide from './component/guide/redux/reducer';
import destination_tree from './component/destinationTree/redux/reducer';
import event from './component/event/redux/reducer';
import extraction from './component/extraction/redux/reducer';
import finished from './component/utils/finished/redux/reducer';
import guide from './component/guide/redux/reducer';
import guide_default_rubric from './component/guideDefaultRubric/redux/reducer';
import header from './component/header/redux/reducer';
import lists from './component/utils/list/redux/reducer';
import loading from './component/utils/loading/redux/reducer';
import locale from './component/locale/redux/reducer';
import login from './component/login/redux/reducer';
import mailTemplate from './component/mailTemplate/redux/reducer';
import manual_accommodation_chain from './component/manualAccommodationChain/redux/reducer';
import manual_flight from './component/manualFlight/redux/reducer';
import manual_flight_folder from './component/manualFlightFolder/redux/reducer';
import margin from './component/margin/redux/reducer';
import navigation from './component/navigation/redux/reducer';
import newsletter from './component/newsletter/redux/reducer';
import newsletterContacts from './component/newsletterContacts/redux/reducer';
import newsletterContactsGroup from './component/newsletterContactsGroup/redux/reducer';
import permissions from './component/permissions/redux/reducer';
import picture from './component/picture/redux/reducer';
import price_model from './component/priceModel/redux/reducer';
import profile from './component/profile/redux/reducer';
import provider from './component/provider/redux/reducer';
import quotation from './component/quotation/redux/reducer';
import quotation_category from './component/quotationCategory/redux/reducer';
import quotation_default_rubric from './component/quotationDefaultRubric/redux/reducer';
import recommended_accommodation from './component/recommendedAccommodation/redux/reducer';
import reset_password from './component/resetPassword/redux/reducer';
import roadbook from './component/roadbook/redux/reducer';
import roadbook_category from './component/roadbookCategory/redux/reducer';
import roadbook_configuration from './component/roadbookConfiguration/redux/reducer';
import roadbook_default_rubric from './component/roadbookDefaultRubric/redux/reducer';
import roadbook_picture_type from './component/roadbookPictureType/redux/reducer';
import { transfer } from './component/transfer/redux/reducer';
import role from './component/role/redux/reducer';
import rooming_list from './component/roomingList/redux/reducer';
import trip from './component/trip/redux/reducer';
import user from './component/user/redux/reducer';
import vehicleModel from './component/vehicleModel/redux/reducer';
import { centralPayment } from './component/centralPayment/redux/reducer';
import { certificate } from './component/certificate/redux/reducer';
import { channelManager } from './component/channelManager/redux/reducer';
import { clientSubdomain } from './component/clientSubdomains/redux/reducer';
import { commercial } from './component/commercial/redux/reducer';
import { commercial_information } from './component/commercialInformation/redux/reducer';
import { companyCode } from './component/companyCode/redux/reducer';
import { corporateCode } from './component/corporateCode/redux/reducer';
import { dmcProvider } from './component/dmcProvider/redux/reducer';
import { insurance_stats } from './component/insurance-stats/redux/reducer';
import { itineraryTypeSlice } from './component/itineraryType/redux/reducer';
import { manualAccommodation } from './component/manualAccommodation/redux/reducer';
import { manualAccommodationStatSlice } from './component/manualAccommodationStat/redux/reducer';
import { manualActivity } from './component/manualActivity/redux/reducer';
import { manualActivityGlobalCancellationRule } from './component/manualActivityCancellationRules/redux/reducer';
import { documentationSlice } from './component/documentation/redux/reducer';
import { destinationParams } from './component/destinationParams/redux/reducer';
import { miniNetwork } from './component/miniNetwork/redux/reducer';
import { network } from './component/network/redux/reducer';
import { organisation } from './component/organisation/redux/reducer';
import { organisationInsurance } from './component/organisations-insurance/redux/reducer';
import { product } from './component/products/redux/reducer';
import { purchase } from './component/purchase/redux/reducer';
import { purchasesReceipt } from './component/purchasesReceipt/redux/reducer';
import { salesReceipt } from './component/salesReceipt/redux/reducer';
import { settlement } from './component/settlement/redux/reducer';
import { sinister } from './component/sinister/redux/reducer';
import { site } from './component/site/redux/reducer';
import { stockStatusSlice } from './component/stockStatus/redux/reducer';
import { translation } from './component/translation/store/reducer';
import { language } from './component/language/redux/reducer';
import { accountSetting } from './component/accountSettings/redux/reducer';
import { network_director } from './component/networkDirector/redux/reducer';
import { accountExportSetting } from './component/accountingExportSettings/redux/reducer';
import { documents } from './component/documentsBank/redux/reducer';
import { marginFlight } from './component/marginFlight/redux/reducer';
import { marginSetting } from './component/marginSetting/redux/reducer';
import { userTeam } from './component/userTeam/redux/reducer';
import { accommodation_rooming_list } from './component/accommodationRoomingList/redux/reducer';
import { fileCategory } from './component/fileCategory/redux/reducer';
import { pictureCategory } from './component/pictureCategory/redux/reducer';
import { text } from './component/utils/texts/redux/reducer';
import { accommodationStock } from './component/accommodationStock/redux/reducer';
import { marketView } from './component/marketView/redux/reducer';
import { accommodationTag } from './component/accommodationTag/redux/reducer';
import { cancelCondition } from './component/cancelCondition/redux/reducer';
import { iataAirline } from './component/iataAirline/redux/reducer';
import { destinationZone } from './component/destinationZone/redux/reducer';
import { circuitRoomingListSlice } from './component/circuitRoomingList/redux/reducer';
import { circuitRoomingListParamsSlice } from './component/circuitRoomingListParams/redux/reducer';
import { departureAirport } from './component/departureAirport/redux/reducer';
import { cms } from './component/cms/redux/reducer';
import { clientDemandSlice } from './component/clientDemand/redux/reducer';
import { lockableFareParameters } from './component/lockableFareParameters/redux/reducer';
import { lockableFareActiveOptions } from './component/lockableFareActiveOptions/redux/reducer';
import { lockableFareActiveBookings } from './component/lockableFareActiveBookings/redux/reducer';
import { workflowConfig } from './component/workflowConfig/redux/reducer';
import { iaMonitoring } from './component/ia/monitoring/redux/reducer';
import { priceCache } from './component/priceCache/redux/reducer';
import { allowedCurrencies } from './component/allowedCurrencies/redux/reducer';
import { circuitStockStatusSlice } from './component/circuitStockStatus/redux/reducer';
import dashboard from './component/dashboard/redux/reducer';
import dashboardSubscriptions from './component/dashboard/dashboardSubscriptions/redux/reducer';
import { sub_network } from './component/subNetwork/redux/reducer';
import { customInsurance } from './component/customInsurance/redux/reducer';
import { customInsuranceBooked } from './component/customInsuranceBooked/redux/reducer';

export const rootReducer = {
    [customInsurance.name]: customInsurance.reducer,
    [customInsuranceBooked.name]: customInsuranceBooked.reducer,
    [accommodation_rooming_list.name]: accommodation_rooming_list.reducer,
    [centralPayment.name]: centralPayment.reducer,
    [certificate.name]: certificate.reducer,
    [channelManager.name]: channelManager.reducer,
    [circuitSlice.name]: circuitSlice.reducer,
    [clientSubdomain.name]: clientSubdomain.reducer,
    [commercial.name]: commercial.reducer,
    [commercial_information.name]: commercial_information.reducer,
    [companyCode.name]: companyCode.reducer,
    [corporateCode.name]: corporateCode.reducer,
    [destinationParams.name]: destinationParams.reducer,
    [dmcProvider.name]: dmcProvider.reducer,
    [documents.name]: documents.reducer,
    [documentationSlice.name]: documentationSlice.reducer,
    [insurance_stats.name]: insurance_stats.reducer,
    [itineraryTypeSlice.name]: itineraryTypeSlice.reducer,
    [language.name]: language.reducer,
    [lists.name]: lists.reducer,
    [accountSetting.name]: accountSetting.reducer,
    [manualAccommodation.name]: manualAccommodation.reducer,
    [manualAccommodationStatSlice.name]: manualAccommodationStatSlice.reducer,
    [manualActivity.name]: manualActivity.reducer,
    [manualActivityGlobalCancellationRule.name]: manualActivityGlobalCancellationRule.reducer,
    [miniNetwork.name]: miniNetwork.reducer,
    [network.name]: network.reducer,
    [sub_network.name]: sub_network.reducer,
    [network_director.name]: network_director.reducer,
    [newsletter.name]: newsletter.reducer,
    [newsletterContacts.name]: newsletterContacts.reducer,
    [newsletterContactsGroup.name]: newsletterContactsGroup.reducer,
    [organisation.name]: organisation.reducer,
    [organisationInsurance.name]: organisationInsurance.reducer,
    [product.name]: product.reducer,
    [purchase.name]: purchase.reducer,
    [fileCategory.name]: fileCategory.reducer,
    [pictureCategory.name]: pictureCategory.reducer,
    [cancelCondition.name]: cancelCondition.reducer,
    [iataAirline.name]: iataAirline.reducer,
    [purchasesReceipt.name]: purchasesReceipt.reducer,
    [salesReceipt.name]: salesReceipt.reducer,
    [settlement.name]: settlement.reducer,
    [sinister.name]: sinister.reducer,
    [site.name]: site.reducer,
    [stockStatusSlice.name]: stockStatusSlice.reducer,
    [translation.name]: translation.reducer,
    [vehicleModel.name]: vehicleModel.reducer,
    [marketView.name]: marketView.reducer,
    [marginFlight.name]: marginFlight.reducer,
    [marginSetting.name]: marginSetting.reducer,
    [userTeam.name]: userTeam.reducer,
    [accommodationTag.name]: accommodationTag.reducer,
    [circuitRoomingListSlice.name]: circuitRoomingListSlice.reducer,
    [circuitRoomingListParamsSlice.name]: circuitRoomingListParamsSlice.reducer,
    [circuitStockStatusSlice.name]: circuitStockStatusSlice.reducer,
    automatic_product,
    circuit,
    circuit_category,
    connected_activities,
    currency,
    [accountExportSetting.name]: accountExportSetting.reducer,
    [accommodationStock.name]: accommodationStock.reducer,
    [departureAirport.name]: departureAirport.reducer,
    [destinationZone.name]: destinationZone.reducer,
    [cms.name]: cms.reducer,
    [lockableFareParameters.name]: lockableFareParameters.reducer,
    [lockableFareActiveOptions.name]: lockableFareActiveOptions.reducer,
    [lockableFareActiveBookings.name]: lockableFareActiveBookings.reducer,
    [workflowConfig.name]: workflowConfig.reducer,
    [iaMonitoring.name]: iaMonitoring.reducer,
    [priceCache.name]: priceCache.reducer,
    [allowedCurrencies.name]: allowedCurrencies.reducer,
    [clientAuth.name]: clientAuth.reducer,
    [clientDemandSlice.name]: clientDemandSlice.reducer,
    [bokun.name]: bokun.reducer,
    custom_currency,
    custom_provider,
    destination,
    destination_category,
    destination_guide,
    destination_tree,
    event,
    extraction,
    finished,
    guide,
    guide_default_rubric,
    header,
    loading,
    locale,
    login,
    mailTemplate,
    manual_accommodation_chain,
    manual_flight,
    manual_flight_folder,
    [transfer.name]: transfer.reducer,
    margin,
    navigation,
    permissions,
    picture,
    price_model,
    profile,
    provider,
    quotation,
    quotation_category,
    quotation_default_rubric,
    recommended_accommodation,
    reset_password,
    roadbook,
    roadbook_category,
    roadbook_configuration,
    roadbook_default_rubric,
    roadbook_picture_type,
    role,
    rooming_list,
    [text.name]: text.reducer,
    trip,
    user,
    dashboard,
    dashboardSubscriptions,
};

export type AppState = {
    [K in keyof typeof rootReducer]: ReturnType<(typeof rootReducer)[K]>
}